<template>
  <div style="height: 100%; padding-left: 90px;">
    <!-- <v-chart class="chart" :option="options" :autoresize="true" /> -->
    <div class="dianchi1">
      <ul>
        <li>
          <p class="wa">64V</p>
          <p class="bianhao">1#</p>
        </li>
      </ul>
    </div>
    <div class="dianchi2">
      <ul>
        <li>
          <p class="wa">64V</p>
          <p class="bianhao">1#</p>
        </li>
      </ul>
    </div>
    <div class="dianchi1">
      <ul>
        <li>
          <p class="wa">64V</p>
          <p class="bianhao">1#</p>
        </li>
      </ul>
    </div>
    <div class="dianchi2">
      <ul>
        <li>
          <p class="wa">64V</p>
          <p class="bianhao">1#</p>
        </li>
      </ul>
    </div>
    <div class="dianchi1">
      <ul>
        <li>
          <p class="wa">64V</p>
          <p class="bianhao">1#</p>
        </li>
      </ul>
    </div>
    <div class="dianchi2">
      <ul>
        <li>
          <p class="wa">64V</p>
          <p class="bianhao">1#</p>
        </li>
      </ul>
    </div>
    <div class="dianchi1">
      <ul>
        <li>
          <p class="wa">64V</p>
          <p class="bianhao">1#</p>
        </li>
      </ul>
    </div>
    <div class="dianchi2">
      <ul>
        <li>
          <p class="wa">64V</p>
          <p class="bianhao">1#</p>
        </li>
      </ul>
    </div>
    <div class="dianchi1">
      <ul>
        <li>
          <p class="wa">64V</p>
          <p class="bianhao">1#</p>
        </li>
      </ul>
    </div>
    <div class="dianchi2">
      <ul>
        <li>
          <p class="wa">64V</p>
          <p class="bianhao">1#</p>
        </li>
      </ul>
    </div>
    <div class="dianchi1">
      <ul>
        <li>
          <p class="wa">64V</p>
          <p class="bianhao">1#</p>
        </li>
      </ul>
    </div>
    <div class="dianchi2">
      <ul>
        <li>
          <p class="wa">64V</p>
          <p class="bianhao">1#</p>
        </li>
      </ul>
    </div>
    <div class="dianchi1">
      <ul>
        <li>
          <p class="wa">64V</p>
          <p class="bianhao">1#</p>
        </li>
      </ul>
    </div>
    <div class="dianchi2">
      <ul>
        <li>
          <p class="wa">64V</p>
          <p class="bianhao">1#</p>
        </li>
      </ul>
    </div>
    <div class="dianchi1">
      <ul>
        <li>
          <p class="wa">64V</p>
          <p class="bianhao">1#</p>
        </li>
      </ul>
    </div>
    <div class="dianchi2">
      <ul>
        <li>
          <p class="wa">64V</p>
          <p class="bianhao">1#</p>
        </li>
      </ul>
    </div>
    <div class="dianchi1">
      <ul>
        <li>
          <p class="wa">64V</p>
          <p class="bianhao">1#</p>
        </li>
      </ul>
    </div>
    <div class="dianchi2">
      <ul>
        <li>
          <p class="wa">64V</p>
          <p class="bianhao">1#</p>
        </li>
      </ul>
    </div>
    <div class="dianchi1">
      <ul>
        <li>
          <p class="wa">64V</p>
          <p class="bianhao">1#</p>
        </li>
      </ul>
    </div>
    <div class="dianchi2" style="margin-right: 0">
      <ul>
        <li>
          <p class="wa">64V</p>
          <p class="bianhao">1#</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, onMounted } from "vue";
//import * as echarts from 'echarts';
export default defineComponent({
  name: "ZuWang",
  components: {},
  props: {},
  setup() {
    const options = ref({});

    onMounted(() => {
      //组件挂载时的生命周期执行的方法
    });

    return {
      options,
    };
  },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.dianchi1 {
  background: url("@/assets/dc6.png") no-repeat top center;
  width: 58px;
  height: 82px;
  text-align: center;
  color: #fff;
  font-weight: bold;
  margin-right: 12px;
  margin-bottom: 35px;
  float: left;
}

.dianchi2 {
  background: url("@/assets/dc7.png") no-repeat top center;
  width: 58px;
  height: 82px;
  text-align: center;
  color: #fff;
  font-weight: bold;
  margin-right: 52px;
  margin-bottom: 35px;
  float: left;
}

.wa {
  padding-top: 30px;
  padding-bottom: 20px;
}
</style>
